module.exports = __webpack_public_path__ + "static/SimonPress-0ef4a43cfaaac61f23e7d9406dadbbb2.png";